import { createStore } from '@evertrue/et-flux';
import LaunchDarklySource from './launch-darkly-source';

/**
 * LaunchDarklyStore - Flux store for LaunchDarkly feature flags
 *
 * This store allows non-React code (like CoffeeScript Flux stores) to access
 * LaunchDarkly flags synchronously. The flags are synced from the React
 * LaunchDarkly provider via the LaunchDarklySource.
 */
export default createStore('LaunchDarklyStore', {
  getInitialState() {
    return {
      flags: {},
      initialized: false,
    };
  },

  registerActions() {
    this.on(LaunchDarklySource.actions.syncFlags, this.respondToSyncFlags);
  },

  respondToSyncFlags(flags) {
    this.setState({
      flags: flags || {},
      initialized: true,
    });
  },

  api: {
    hasFlag(flagName) {
      const flags = this.getState('flags');
      return flags.hasOwnProperty(flagName) ? Boolean(flags[flagName]) : false;
    },

    getFlagValue(flagName, defaultValue = false) {
      const flags = this.getState('flags');
      return flags.hasOwnProperty(flagName) ? flags[flagName] : defaultValue;
    },

    isInitialized() {
      return this.getState('initialized');
    },

    getAllFlags() {
      return this.getState('flags');
    },
  },
});
